import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngRowPin extends ngCellEx
{
	constructor () {
		super();

		this.applyBaseStyle();
	}

	connectedCallback() {

		this.shadowRoot.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" focusable="false" aria-hidden="true">
				<path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"/>
			</svg>
		`;

		super.connectedCallback();
		
		this.#init();
	};
	
	dataRefresh = (v) => {
		if (!this.owner || !this.cell || !this.data) return;
		
		this.cell.closest("tbody.fixed") ? ninegrid.j.querySelectorAll(this).addClass("pin") : ninegrid.j.querySelectorAll(this).removeClass("pin");
		
		if (!v) this.reset();
	};
	
	#init = () => {
		
		/** Mobile에서 Row Pin 기능 방지 */
		if (!ninegrid.isMobile()) {
			this.shadowRoot.querySelector("svg").addEventListener("click", e => {
				
				const row = this.cell.closest("tr").dataset.row;
				
				this.cell.closest("tbody.fixed") ? this.owner.pin.remove(row) : this.owner.pin.add(this.data.__ng._[ninegrid.ROW.INDEX]);
			});
		}
	}
}


export class ngPinManager
{
	#owner;
	#records;
	
	constructor(owner) {
		this.#owner = owner;
		this.#records = [];
	}

	initialize = () => {
		/**
		 * 1. grid attr == filter : on();
		 */
		this.#records.forEach(v => {
			v.__ng._[ninegrid.ROW.PIN] = false;
		})

		this.#records = [];

		this.#owner.data.resetRecords();
	};
	
	add = (index) => {

		//var data = this.#owner.data.getRow(i);
		var data = this.#owner.data.getNF(index);
		data.__ng._[ninegrid.ROW.PIN] = true;
		
		this.#records.push(data);
		

		
		var leftTmpl	= this.#owner.template.clone();
		var rightTmpl	= this.#owner.template.clone();
		var bodyTmpl	= this.#owner.template.clone();
	
		leftTmpl	.find("th,td").not("[fixed=left]").remove();
		rightTmpl	.find("th,td").not("[fixed=right]").remove();
		bodyTmpl	.find("th[fixed=left],td[fixed=left],th[fixed=right],td[fixed=right]").remove();
		
		//this.#records.sort((a,b) => {return a.__ng.rowidx-b.__ng.rowidx});
		leftTmpl	.each((i,tr) => { $(".ng-container-left tbody.fixed",	this.#owner.body).append(tr.outerHTML); });
		rightTmpl	.each((i,tr) => { $(".ng-container-right tbody.fixed",	this.#owner.body).append(tr.outerHTML); });
		bodyTmpl	.each((i,tr) => { $(".ng-container-body tbody.fixed",	this.#owner.body).append(tr.outerHTML); });

		$("tbody.fixed tr:not([data-index])", this.#owner.body).each((i,tr) => {
			tr.dataset.index = data.__ng._[ninegrid.ROW.INDEX];
			tr.data = data;
		});
		
		$("tbody.fixed tr", this.#owner.body).each((i,tr) => {
			tr.dataset.row = (this.#records.length - parseInt(tr.sectionRowIndex / this.#owner.template.length)) * -1;
			//tr.data = data;
		});

		$("tbody.fixed tr", this.#owner.body).each((i,tr) => {
			tr.dataset.matrixRow	= parseInt(tr.dataset.row) * this.#owner.template.length + (parseInt(tr.sectionRowIndex % this.#owner.template.length));
			ninegrid.j.querySelectorAll("th,td", tr).attr("data-index",		tr.dataset.index);
			ninegrid.j.querySelectorAll("th,td", tr).attr("data-row",		tr.dataset.row);
			ninegrid.j.querySelectorAll("th,td", tr).attr("data-matrix-row",	tr.dataset.matrixRow);
		});

		this.#owner.data.resetRecords();
		this.#owner.dataManager.viewRecords.reset();
	};

	remove = (row) => {
		
		var data = this.#owner.body.querySelector(`.ng-container-body tbody.fixed tr[data-row="${row}"]`).data;
		var index = this.#records.findIndex(m => { return m.__ng.rowid == data.__ng.rowid } );
		
		if (index >= 0) {
			$(`.ng-container-left	tbody.fixed tr[data-row=${row}]`, this.#owner.body).remove();
			$(`.ng-container-right	tbody.fixed tr[data-row=${row}]`, this.#owner.body).remove();
			$(`.ng-container-body	tbody.fixed tr[data-row=${row}]`, this.#owner.body).remove();
			
			this.#records[index].__ng._[ninegrid.ROW.PIN] = false;
			
			this.#records.splice(index, 1);
		}
		
		this.#owner.data.resetRecords();
		this.#owner.dataManager.viewRecords.reset();
	};
	
	get = (at) => {
		return (at == null) ? this.#records : this.#records[at];
	}

	includes = (i) => {

		if (isNaN(i)) return;
		
		return this.#records.findIndex(m => m.__ng.i == i) >= 0 ? true : false; 
	}
	
	count = () => {
		return this.#records.length;
	}
}


if (!customElements.get('ng-row-pin')) {
	customElements.define("ng-row-pin", ngRowPin);
}

